import { render, staticRenderFns } from "./PeriodCalendar.vue?vue&type=template&id=6b237ea2&scoped=true&"
import script from "./PeriodCalendar.vue?vue&type=script&lang=js&"
export * from "./PeriodCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b237ea2",
  null
  
)

export default component.exports